var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyewear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main_icons",
    "data-name": "Main icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "14 7.99 14 8 18 8 18 4 14 4 14 7.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32,4h-2V1c0-.55-.45-1-1-1h-10c-.55,0-1,.45-1,1v3h8v8h-3.97l-4.01-4.01v5.66s2.35,2.35,2.35,2.35h0s0,0,0,0h8.63c.55,0,1-.45,1-1v-7h2v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6,12V4h8V1c0-.55-.45-1-1-1H3c-.55,0-1,.45-1,1v3H0v4h2v7c0,.55.45,1,1,1h8.65l2.35-2.35v-5.66s-4.01,4.01-4.01,4.01h-3.99Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyewear);
export default __webpack_public_path__ + "static/media/eyewear.338f23287b7dea6dc5114d2ee9c57d7e.svg";
export { ForwardRef as ReactComponent };